import { __module as d } from "./chunk680.js";
import { __require as L } from "./chunk447.js";
import { __require as Q } from "./chunk451.js";
import { __require as T } from "./chunk453.js";
import { __require as Y } from "./chunk463.js";
import { __require as Z } from "./chunk464.js";
var J = d.exports, $;
function X() {
  return $ ? d.exports : ($ = 1, function(j, K) {
    (function(m, l, b) {
      j.exports = l(L(), Q(), T(), Y(), Z());
    })(J, function(m) {
      return function() {
        var l = m, b = l.lib, g = b.BlockCipher, D = l.algo, n = [], z = [], P = [], k = [], H = [], I = [], q = [], h = [], C = [], y = [];
        (function() {
          for (var r = [], f = 0; f < 256; f++)
            f < 128 ? r[f] = f << 1 : r[f] = f << 1 ^ 283;
          for (var v = 0, e = 0, f = 0; f < 256; f++) {
            var x = e ^ e << 1 ^ e << 2 ^ e << 3 ^ e << 4;
            x = x >>> 8 ^ x & 255 ^ 99, n[v] = x, z[x] = v;
            var _ = r[v], o = r[_], a = r[o], i = r[x] * 257 ^ x * 16843008;
            P[v] = i << 24 | i >>> 8, k[v] = i << 16 | i >>> 16, H[v] = i << 8 | i >>> 24, I[v] = i;
            var i = a * 16843009 ^ o * 65537 ^ _ * 257 ^ v * 16843008;
            q[x] = i << 24 | i >>> 8, h[x] = i << 16 | i >>> 16, C[x] = i << 8 | i >>> 24, y[x] = i, v ? (v = _ ^ r[r[r[a ^ _]]], e ^= r[r[e]]) : v = e = 1;
          }
        })();
        var F = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], G = D.AES = g.extend({
          _doReset: function() {
            var r;
            if (!(this._nRounds && this._keyPriorReset === this._key)) {
              for (var f = this._keyPriorReset = this._key, v = f.words, e = f.sigBytes / 4, x = this._nRounds = e + 6, _ = (x + 1) * 4, o = this._keySchedule = [], a = 0; a < _; a++)
                a < e ? o[a] = v[a] : (r = o[a - 1], a % e ? e > 6 && a % e == 4 && (r = n[r >>> 24] << 24 | n[r >>> 16 & 255] << 16 | n[r >>> 8 & 255] << 8 | n[r & 255]) : (r = r << 8 | r >>> 24, r = n[r >>> 24] << 24 | n[r >>> 16 & 255] << 16 | n[r >>> 8 & 255] << 8 | n[r & 255], r ^= F[a / e | 0] << 24), o[a] = o[a - e] ^ r);
              for (var i = this._invKeySchedule = [], t = 0; t < _; t++) {
                var a = _ - t;
                if (t % 4)
                  var r = o[a];
                else
                  var r = o[a - 4];
                t < 4 || a <= 4 ? i[t] = r : i[t] = q[n[r >>> 24]] ^ h[n[r >>> 16 & 255]] ^ C[n[r >>> 8 & 255]] ^ y[n[r & 255]];
              }
            }
          },
          encryptBlock: function(r, f) {
            this._doCryptBlock(r, f, this._keySchedule, P, k, H, I, n);
          },
          decryptBlock: function(r, f) {
            var v = r[f + 1];
            r[f + 1] = r[f + 3], r[f + 3] = v, this._doCryptBlock(r, f, this._invKeySchedule, q, h, C, y, z);
            var v = r[f + 1];
            r[f + 1] = r[f + 3], r[f + 3] = v;
          },
          _doCryptBlock: function(r, f, v, e, x, _, o, a) {
            for (var i = this._nRounds, t = r[f] ^ v[0], u = r[f + 1] ^ v[1], p = r[f + 2] ^ v[2], c = r[f + 3] ^ v[3], s = 4, W = 1; W < i; W++) {
              var A = e[t >>> 24] ^ x[u >>> 16 & 255] ^ _[p >>> 8 & 255] ^ o[c & 255] ^ v[s++], E = e[u >>> 24] ^ x[p >>> 16 & 255] ^ _[c >>> 8 & 255] ^ o[t & 255] ^ v[s++], N = e[p >>> 24] ^ x[c >>> 16 & 255] ^ _[t >>> 8 & 255] ^ o[u & 255] ^ v[s++], V = e[c >>> 24] ^ x[t >>> 16 & 255] ^ _[u >>> 8 & 255] ^ o[p & 255] ^ v[s++];
              t = A, u = E, p = N, c = V;
            }
            var A = (a[t >>> 24] << 24 | a[u >>> 16 & 255] << 16 | a[p >>> 8 & 255] << 8 | a[c & 255]) ^ v[s++], E = (a[u >>> 24] << 24 | a[p >>> 16 & 255] << 16 | a[c >>> 8 & 255] << 8 | a[t & 255]) ^ v[s++], N = (a[p >>> 24] << 24 | a[c >>> 16 & 255] << 16 | a[t >>> 8 & 255] << 8 | a[u & 255]) ^ v[s++], V = (a[c >>> 24] << 24 | a[t >>> 16 & 255] << 16 | a[u >>> 8 & 255] << 8 | a[p & 255]) ^ v[s++];
            r[f] = A, r[f + 1] = E, r[f + 2] = N, r[f + 3] = V;
          },
          keySize: 256 / 32
        });
        l.AES = g._createHelper(G);
      }(), m.AES;
    });
  }(d), d.exports);
}
export {
  X as __require
};
